<template>
  <div v-show="isLoaded" class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/reviews/scientist">{{textContent.title}}</router-link>
          <span></span>
          <h1>{{copyItem.name}}</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="folder radius">
          <div class="column caption">
            <p>Редактирование отзыва</p>
          </div>
          <div class="column">
            <div class="content">
              <new-input title="Имя автора" name="name"></new-input>
              <calendar name="created_at" title="Дата создания"></calendar>
              <edit-file class="short align-top" use-case="cover" v-if="isLoaded" title="Изображение"
                         name="img"/>
              <new-text-area title="Отзыв" name="message"></new-text-area>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onSubmit">{{textContent.saveButton}}</button>
          <button class="cancel" @click="reset">{{textContent.cancelButton}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconUpload from '@/components/icons/IconUpload'
  import NewTextArea from '@/components/edit-form/new-items/TextArea'
  import NewInput from '@/components/edit-form/new-items/Input'
  import OldInput from '@/components/edit-form/old-items/Input'
  import OldTextArea from '@/components/edit-form/old-items/TextArea'
  import OldEditor from '@/components/edit-form/old-items/Editor'
  import EditDropDown from '@/components/edit-form/DropDown'
  import EditFile from '@/components/edit-form/File'
  import {createNamespacedHelpers} from 'vuex'
  import Calendar from '../../../../edit-form/Calendar'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')

  export default {
    data: function () {
      return {
        ckeditor: null,
        text: ''
      }
    },
    computed: {
      ...mapState([
        'isLoaded',
        'item',
        'copyItem',
        'textContent'
      ]),
      apiUrls() {
        return this.$store.state.apiUrls
      }
    },
    methods: {
      ...mapActions([
        'init',
        'edit',
        'reset'
      ]),
      ...mapMutations([
        'resetModule',
        'setFileExtensions',
        'setItemField'
      ]),
      onSubmit() {
        this.edit({
          name: this.item.name,
          created_at: this.item.created_at,
          img: this.item.img,
          message: this.item.message
        })
      }
    },
    mounted() {
    },
    created() {
      this.resetModule();
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.init({
        textContent: {
          title: 'Отзывы Олег Мальцев',
          cancelButton: 'Отмена',
          saveButton: 'Сохранить',
          greeting: 'Все изменения успешно сохранены',
          subtitle: 'Редактирование отзыва',
        },
        errors: {
          name: {message: 'Введите имя автора', hasError: false},
          created_at: {message: 'Выберите дату создания', hasError: false},
          img: {message: 'Допустимые расширения: jpg, jpeg, png, gif', hasError: false},
          message: {message: 'Введите текст отзыва', hasError: false},
        },
        itemId: this.$route.params.id,
        apiUrl: this.apiUrls.feedback
      })
    },
    components: {
      Calendar,
      NewTextArea,
      NewInput,
      OldInput,
      OldTextArea,
      OldEditor,
      EditDropDown,
      EditFile,
      IconUpload
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/reviews/scientist/pages/Edit.vue